import { useState } from "react";
import styled from "styled-components";
import Button from "../../../sharedUI/Button";
import SVG from "../../../sharedUI/SVG";
import { measurments } from "../../../utils/config";
import MediaLibrary from "../../ui/MediaLibrary";
import ResponsiveVideo from "../view/ResponsiveVideo";

const StyledVideoEdit = styled.div`
  margin-bottom: 1rem;
  .library-container {
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(10, 10, 10, 0.25);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    &-inner {
      background: white;
      padding: 1rem;
      border-radius: ${measurments.borderRadius}px;
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
      max-width: calc(${measurments.contentWidth}px - 1rem);
      width: 100%;
      max-height: 80vh;
      height: 100%;
      overflow-y: scroll;
      position: relative;
      .library-container-close {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        button {
          padding: 0.3rem 0.5rem;
          svg {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }
`;

const VideoEdit = ({ content, setContentData, outlet }) => {
  //States
  const [libraryOpen, setLibraryOpen] = useState(false);

  const selectVideo = (video) => {
    setContentData({
      ...content.data,
      file: video,
    });
    setLibraryOpen(false);
  };

  return (
    <StyledVideoEdit>
      <>
        <ResponsiveVideo file={content.data.file} />
        <div className="flex jce mtop05">
          <Button onClick={() => setLibraryOpen(true)} btnType="neutral">
            {content.data.file?.name ? "Byt film" : "Välj film"}
          </Button>
        </div>
      </>
      {libraryOpen && (
        <div className="library-container">
          <div className="library-container-inner">
            <div className="library-container-close">
              <Button btnType="neutral" onClick={() => setLibraryOpen(false)}>
                <SVG name="x" stroke="black" />
              </Button>
            </div>
            <MediaLibrary
              handleSelect={selectVideo}
              type="video"
              outlet={outlet}
            />
          </div>
        </div>
      )}
    </StyledVideoEdit>
  );
};

export default VideoEdit;
